<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
 <script>
export default {
  provide () {
    return {
      style: '',
      reload: this.reload
    }
  },
  data () {
    return {
      style: '',
      isRouterAlive: true
    }
  },
  created () {
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
</style>
